import { toCents } from '@/utils/helpers';
import moment from 'moment';

const DATE_FORMAT = 'MM/DD/YYYY';

export default {
  props: {
    slim: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
      default: [],
    },
  },
  computed: {
    tableModifiers() {
      return {
        'order-book__table': true,
        'order-book__table--slim': this.slim,
      };
    },
    shares() {
      return this.items.map((s) => {
        const shares = {
          ...s,
          pricePerShare: toCents(s.pricePerShare),
          dateExecuted: moment(s.dateExecuted).format(DATE_FORMAT),
        };
        return shares;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/order-book/order-book-shares/order-book-shares.js